import { chooseLanguage } from "@/utils/global";

export default {
  state: {
    language: chooseLanguage(),
  },
  getters: {
    language: (state) => state.language,
  },
  mutations: {
    setLanguage: (state, language) => {
      state.language = language;
    },
  },
};
